// removed by extract-text-webpack-plugin
module.exports = {"login-back":"login-back","salt-pagelayout":"salt-pagelayout","sub-title":"sub-title","sub-title-disable":"sub-title-disable","page-title":"page-title","page-sub-title":"page-sub-title","page-sub-title-content":"page-sub-title-content","active":"active","page-tabs":"page-tabs","ant-tabs-bar":"ant-tabs-bar","ant-tabs-nav":"ant-tabs-nav","ant-tabs-tab-inner":"ant-tabs-tab-inner","ant-tabs-tab-active":"ant-tabs-tab-active","ant-tabs-ink-bar":"ant-tabs-ink-bar","ant-btn-primary":"ant-btn-primary","wrapper-box":"wrapper-box","ant-modal-close":"ant-modal-close"};


//////////////////
// WEBPACK FOOTER
// ./src/app/core/Layout/Index.scss
// module id = 933
// module chunks = 0